import Programa from '../../../components/Programa/Programa'
import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useReducer,
  useState,
} from 'react'
import MntPontoDeVenda from './Edicao'
import ListaPontoVenda from './lista'
import ModalSelecionaPontoVenda from './modal/modalSelecionaPontoVenda'
import { LuMoveLeft, LuPlus } from 'react-icons/lu'
import { GlobalContext } from '../../../App'
import { BsShopWindow } from 'react-icons/bs'
import { useParams } from 'react-router-dom'
import { metodoPrograma } from '../../../components/api'

export const barraInicial = [
  [<LuPlus key={'btn-inserir'} />, 'Inserir Venda', 'cadastrarVenda'],
]

export const barraInicialPontoVenda = [
  [
    <BsShopWindow key={'btn-trocarPontoVenda'} />,
    'Trocar Ponto de Venda',
    'trocarPontoVenda',
  ],
  [<LuPlus key={'btn-inserir'} />, 'Inserir Venda', 'cadastrarVenda'],
]

export const barraVoltar = [
  [<LuMoveLeft key={'btn-voltar'} />, 'Voltar', 'lista'],
]

export const listaSituacaoPedido = [
  ['0', 'Em preparação'],
  ['1', 'Pronto para cobrança'],
  ['2', 'Cobrado'],
  ['9', 'Cancelado'],
]

const initialValues = {
  idPontoVenda: null,
  qtIdPontoVenda: 0,
  tela: 'modal',
  reload: true,
  barraFerramenta: barraInicial,
  cadastroVenda: {
    snCobraCheckout: 'N',
    idPedidoVenda: null,
    acAtendimento: [],
    acCliente: null,
    listaProduto: [],
    acFormaPagamento: [],
    acCondicaoPagamento: [],
    vlDesconto: 0,
    prDesconto: 0,
    vlTotal: 0,
    tpSituacao: '0',
  },
  dispatch: () => null,
}

function reducer(state, { type, field, value }) {
  switch (type) {
    case 'reload':
      return { ...state, reload: !state.reload }
    case 'tela':
      return { ...state, tela: value }
    case 'idPontoVenda':
      return {
        ...state,
        idPontoVenda: value,
        barraFerramenta:
          state.qtIdPontoVenda > 1 ? barraInicialPontoVenda : barraInicial,
      }
    case 'barraFerramenta':
      if (value === barraInicial && state.qtIdPontoVenda > 1)
        return { ...state, barraFerramenta: barraInicialPontoVenda }

      return { ...state, barraFerramenta: value }
    case 'cadastroVenda':
      if (field)
        return {
          ...state,
          cadastroVenda: { ...state.cadastroVenda, [field]: value },
        }
      return {
        ...state,
        cadastroVenda: value,
      }
    case 'venda':
      return { ...state, barraFerramenta: barraVoltar, tela: 'venda' }
    case 'limpaCadastroVenda':
      return {
        ...state,
        cadastroVenda: initialValues.cadastroVenda,
      }

    default:
      return !!field && !!type && !!value
        ? { ...state, [type]: { ...state?.[type], [field]: value } }
        : type && !!value
          ? { ...state, [type]: value }
          : { state }
  }
}

export const PontoDeVendaContext = createContext(initialValues)

const PontoDeVenda = () => {
  const { lojaPontoVenda } = useContext(GlobalContext)
  const { urlIdPedidoVenda, urlIdPontoVenda } = useParams()

  const [openModal, setOpenModal] = useState(
    !lojaPontoVenda?.idPontoVenda && !urlIdPontoVenda,
  )

  const [state, dispatch] = useReducer(reducer, initialValues)

  const selecionaPontoVenda = useCallback(
    async (linha) => {
      const { status, dados, itens } = await metodoPrograma(
        'getDadosUrlPontoVenda',
        {
          idPonto: urlIdPontoVenda,
          idPedido: urlIdPedidoVenda,
        },
      )

      const payload = {
        idPedidoVenda: dados?.[0] || null,
        acCliente: dados?.[5] || [],
        acAtendimento: dados?.[2] || [],
        acFormaPagamento: dados?.[10] || [],
        listaProduto:
          status && itens?.length
            ? itens.map((v) => ({
                idx: Symbol('idx ' + v?.idProduto),
                ...v,
                vlUnitarioInicial: v?.vlUnitario || 0,
              }))
            : [],
        vlDesconto: dados?.[16] || 0,
        prDesconto: dados?.[17] || 0,
        tpSituacao: linha?.[9] || '0',
      }

      dispatch({ type: 'cadastroVenda', value: payload })
    },
    [urlIdPedidoVenda, urlIdPontoVenda],
  )

  const provideValue = useMemo(() => ({ ...state, dispatch }), [state])
  const handleCloseModal = (id, qtd) => {
    if (id) {
      dispatch({ type: 'qtIdPontoVenda', value: qtd })
      dispatch({ type: 'idPontoVenda', value: id })
      dispatch({ type: 'reload' })
      setOpenModal(false)
      return dispatch({ type: 'tela', value: 'lista' })
    }
  }

  const handleBarraFerramentas = (chave) => {
    switch (chave) {
      case 'cadastrarVenda':
        dispatch({ type: 'barraFerramenta', value: barraVoltar })
        dispatch({ type: 'tela', value: 'venda' })
        return dispatch({ type: 'tela', value: 'venda' })
      case 'lista':
        dispatch({ type: 'limpaCadastroVenda' })
        dispatch({ type: 'barraFerramenta', value: barraInicial })

        return dispatch({ type: 'tela', value: 'lista' })

      case 'trocarPontoVenda':
        setOpenModal(true)

        return
      default:
        return null
    }
  }

  useEffect(() => {
    if (urlIdPedidoVenda) {
      setOpenModal(false)
      dispatch({ type: 'idPontoVenda', value: urlIdPontoVenda })
      dispatch({ type: 'venda' })
      selecionaPontoVenda()
      window.history.replaceState(
        null,
        '',
        '/programas/financeiro_loja/ponto_de_venda',
      )
      return
    }

    if (lojaPontoVenda?.idPontoVenda) {
      dispatch({ type: 'idPontoVenda', value: lojaPontoVenda?.idPontoVenda })
      dispatch({ type: 'tela', value: 'lista' })
    }
  }, [
    lojaPontoVenda?.idPontoVenda,
    selecionaPontoVenda,
    urlIdPedidoVenda,
    urlIdPontoVenda,
  ])

  return (
    <Programa
      style={{ width: '100%' }}
      codigo="CtrlPontoVenda"
      ferramentas={state.barraFerramenta}
      onClickFerramentas={handleBarraFerramentas}
    >
      <PontoDeVendaContext.Provider value={provideValue}>
        {!urlIdPedidoVenda && (
          <ModalSelecionaPontoVenda
            open={openModal}
            onClose={handleCloseModal}
          />
        )}
        {(() => {
          switch (state.tela) {
            case 'venda':
              return <MntPontoDeVenda />

            case 'lista':
              return <ListaPontoVenda />

            default:
              return null
          }
        })()}
      </PontoDeVendaContext.Provider>
    </Programa>
  )
}

export default PontoDeVenda
